import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useConstitutionModal } from '../context/ConstitutionModalContext';

const ConstitutionModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useConstitutionModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('Constitution')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default ConstitutionModalHeader;
